import {Box, styled} from "@mui/system";

export const PaginationContainer = styled(Box)(
  ({theme}) => `
  padding: 40px 0 40px 0;
  display:flex;
  justify-content: center;
  align-items: center;
`
);
